import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '../../Utility/Grid';
import { StyledSlide, StyledHeading, StyledImageColumn, StyledImageContainer } from './Slide.styles';

export default class Slide extends Component {
  static propTypes = {
    /**
     * The background image on the Slide, this will overlap and imageor color set on the entire carousel so should be used with caution.
     *  - backgroundImage and backgroundColor can not be used together, the image will win out over the color.
     */
    backgroundImage: PropTypes.string,
    /**
     * The background color on the Slide, this will overlap and image or color set on the entire carousel so should be used with caution.
     *  - backgroundImage and backgroundColor can not be used together, the image will win out over the color.
     */
    backgroundColor: PropTypes.string,
    /**
     * Top Row is the Heading for the Slide. Can contain any element.According to current Comps will often be a image or text.
     */
    topRow: PropTypes.node,
    /**
     * The middle row of the Slide. Body content or images can be included here.
     */
    middleRow: PropTypes.node,
    /**
     * The Bottom row of the slide. This will contain a logo according to current comps
     */
    bottomRow: PropTypes.node,
    children: PropTypes.node
  };

  static defaultProps = {
    topRow: undefined,
    backgroundImage: undefined,
    middleRow: '',
    bottomRow: undefined,
    backgroundColor: '',
    children: null
  };

  render() {
    const { topRow, middleRow, bottomRow, backgroundColor, backgroundImage, children } = this.props;
    return (
      <StyledSlide backgroundImage={backgroundImage} backgroundColor={backgroundColor}>
        <Grid.Row>
          <StyledHeading xs={10} md={8} offset={{ xs: 1, md: 2 }} align="center">
            {topRow}
          </StyledHeading>
          <Grid.Col xs={10} md={8} offset={{ xs: 1, md: 2 }}>
            {middleRow}
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <StyledImageColumn xs={10} md={8} offset={{ xs: 1, md: 2 }} align="center">
            <StyledImageContainer>{bottomRow}</StyledImageContainer>
          </StyledImageColumn>
          {children}
        </Grid.Row>
      </StyledSlide>
    );
  }
}
